module.exports = __webpack_public_path__ + "img/元数据目录权限.15818877.svg";